export default "__VITE_ASSET__CcPx5$Nh__"